import { Component, OnInit } from "@angular/core";
import { UtilsService } from "../../../../auth/service/utils.service";
import { RequestService } from "../../../../modules/recruitment/requests/request.service";
import moment from "moment";

@Component({
  selector: "app-last-proposed-candidate",
  templateUrl: "./last-proposed-candidate.component.html",
  styleUrls: ["./last-proposed-candidate.component.scss"],
})
export class LastProposedCandidateComponent implements OnInit {
  public candidateProposedList: any = [];

  public arrayLength: number = 0;

  public step_status_filter: any = [];

  constructor(
    public _requestService: RequestService,
    public _utilService: UtilsService,
  ) {}

  async ngOnInit() {
    this.step_status_filter = [
      { name: await this._utilService.translate("STATUS_STEP_SINGULAR.STEP_0"), value: 0 },
      { name: await this._utilService.translate("STATUS_STEP_SINGULAR.STEP_1"), value: 1 },
      { name: await this._utilService.translate("STATUS_STEP_SINGULAR.STEP_2"), value: 2 },
      { name: await this._utilService.translate("STATUS_STEP_SINGULAR.STEP_3"), value: 3 },
      { name: await this._utilService.translate("STATUS_STEP_SINGULAR.STEP_4"), value: 4 },
      { name: await this._utilService.translate("STATUS_STEP_SINGULAR.STEP_5"), value: 5 },
      { name: await this._utilService.translate("STATUS_STEP_SINGULAR.STEP_6"), value: 6 },
    ];
    this.candidateProposedList = await this._requestService.getEligibleUsers();
    const step_colors: string[] = ["secondary", "warning", "info", "info", "danger", "success", "primary"];
    this.candidateProposedList.map(async (item: any) => {
      item.label_step = `STATUS_STEP_SINGULAR.STEP_${item.data.step}`;
      item.color_step = step_colors[item.data.step];
    });

    this.arrayLength = this.candidateProposedList.length - 5;
    this.candidateProposedList = this.candidateProposedList.sort((a: any, b: any) => {
      return moment(b.data.insert_date).format("YYYY-MM-DD") > moment(a.data.insert_date).format("YYYY-MM-DD") ? 1 : -1;
    });
    this.candidateProposedList = this.candidateProposedList.slice(0, 5);
  }
}
